import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Alert } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'

export function CourseDeletionDialog({
  open,
  title,
  pending,
  error,
  onClose,
  onDelete,
}: {
  open: boolean
  title: string
  pending: boolean
  error: string | null
  onClose: () => void
  onDelete: () => void
}) {
  return (
    <Dialog
      open={open}
      onOpenChange={(open) => {
        if (!open && !pending) onClose()
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete course?</DialogTitle>
          <DialogDescription>
            This permanently removes “{title}”. This action cannot be undone.
          </DialogDescription>
        </DialogHeader>
        {error && <Alert>{error}</Alert>}
        <DialogFooter>
          <Button variant="outline" disabled={pending} onClick={onClose}>
            Cancel
          </Button>
          <Button variant="destructive" disabled={pending} onClick={onDelete}>
            {pending ? 'Deleting…' : 'Delete course'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
